import { render, staticRenderFns } from "./modal-add-edit-brands.vue?vue&type=template&id=f4d42018&scoped=true&lang=pug"
import script from "./modal-add-edit-brands.js?vue&type=script&lang=js&external"
export * from "./modal-add-edit-brands.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-edit-brands.vue?vue&type=style&index=0&id=f4d42018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d42018",
  null
  
)

export default component.exports